import img61 from './EquipoMedico/img61.jpg'
import img62 from './EquipoMedico/img62.jpg'
import { Footer } from './Footer'
import React, { Component } from 'react'
import { Card, Row, Col, Container } from 'react-bootstrap'
import { Navigation } from './Navigation'

export class Emergencia extends Component {
    render() {
        const productos = [
            { img: img61, title: "Salas de emergencia I" },
            { img: img62, title: "Salas de emergencia II" }
        ];

        return (
            <div>
                <Navigation />
                <Container fluid className="px-5">
                    <br />
                    <Row>
                        <Col className="text-center">
                            <h1>Emergencia</h1>
                        </Col>
                    </Row>
                    <br />

                    {/* Estándar Encamamiento: 2 columnas (lg={2}) para máximo detalle visual */}
                    <Row xs={1} md={2} lg={2} className="g-5 text-center justify-content-center">
                        {productos.map((item, idx) => (
                            <Col key={idx}>
                                <Card className="h-100 shadow border-0">
                                    <Card.Body className="p-2">
                                        <Card.Img 
                                            variant="top" 
                                            src={item.img} 
                                            style={{ 
                                                height: '550px', // Altura unificada con Encamamiento
                                                objectFit: 'contain', 
                                                width: '100%',
                                                padding: '10px' 
                                            }} 
                                        />
                                    </Card.Body>
                                    {/* Usamos Card.Footer para separar el texto y darle un aire más premium */}
                                    <Card.Footer className="bg-white border-0">
                                        <Card.Title style={{ fontSize: '1.8rem', padding: '10px' }}>
                                            {item.title}
                                        </Card.Title>
                                    </Card.Footer>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                    <br />
                </Container>
                <Footer />
            </div>
        )
    }
}